import { useState } from "react";
import HerosectionHeader from "../../../../Componet/Herosection/HerosectionHeader";
import { Row, Col, Container, Table, Label, Input } from "reactstrap";
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";
import SpinnerButton from "../../../../Componet/Button/SpinnerButton";
import { OrderTransactionData, CoversionMethodTypeData } from "../../../../store/Utility/Utility";
import { QuotationStepData } from "../../../../store/Utility/Utility";
import VehicleTypeIcon from "../../../../Componet/VehicleTypeIcon";
import moment from "moment";
import { OrderCancelationType, QuotationStatus, QuotationStep, ConversionMethodType } from "../../../../store/Utility/Status";
import EmptyDataResult from "../../../../Componet/EmptyDataResult";
import { useSpinner } from "../../../../context/SpinnerContext";
import Modal from "react-bootstrap/Modal";
import AutoCompleteInput from "../../../../Componet/Autocomplete/AutoCompleteInput";


const ConvertOrderInitialValue =
{
    paymentIntentId: null,
    description: null,
    show: false,
    header: null,
    message: null,
    isError: null,
    validationError: {},
    transferItem: '',
    selectedReason: '',
    description: null,
    error:null
}

const Transaction = () => {
    const [transaction, setTransaction] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState(QuotationStatus.Abandoned);
    const axiosPrivate = useAxiosPrivate();
    const { showLoader, hideLoader } = useSpinner();
    const [convertOrderModal, setConvertOrderModal] = useState(ConvertOrderInitialValue);
    const [awaitingTransfer, setAwaitingTransfer] = useState();

    const handleOptionChange = (e) => {
        setSelectedStatus(e.target.value);
    };

    const fetchTransactions = async () => {
        setLoading(true);
        // var selectedItem = QuotationStatusData.find(t => t.id == selectedStatus);
        // if (!selectedItem) return;
        await axiosPrivate.get(`v1/quotation/transactions`,
            {
                params:
                {
                    status: selectedStatus
                },
            }).then(res => {
                setTransaction(res.data.data);

            });
        setLoading(false);
    };

    const onSendReminder = async (id) => {
        showLoader();
        const response = await axiosPrivate.post(`v1/quotation/order-reminder`, JSON.stringify(id)).then(res => {
            // showModal({ show: true, message: "Inspector succesfully approved!" });
            // hideLoader();
            fetchTransactions();
        }).catch(error => {
            // showModal({ show: true, message: "Sorry! An error occured" });
            hideLoader();
        });
        hideLoader();
    }

    const onSearchClick = (e) => {
        if (loading) return;
        fetchTransactions();
    }

    const fetchInspectors = async (e) => {

    };

    const onConfirmConvertOrder = async () => {
        showLoader();


        var request = {
            quotationId: convertOrderModal.id,
            conversionMethod: Number(convertOrderModal.selectedReason),
            paymentIntentId: convertOrderModal.paymentIntentId,
            description: convertOrderModal.description
        };

        if (convertOrderModal.selectedReason == ConversionMethodType.Transfer) {
            request.paymentIntentId = convertOrderModal.selectedTransferItem.transferredIntentId;
            request.transferredQuotationId = convertOrderModal.selectedTransferItem.transferredQuotationId;
        }

        const response = await axiosPrivate.post(`v1/quotation/transfer-order`, request).then(res => {
            // showModal({ show: true, message: "Inspector succesfully approved!" });
            // hideLoader();
            fetchTransactions();
            getAwaitingTransfer();
            setConvertOrderModal(ConvertOrderInitialValue)
        }).catch(err => {
            // showModal({ show: true, message: "Sorry! An error occured" });
            setConvertOrderModal((prevFormData) => ({ ...prevFormData, error: err?.response?.data?.Error }))
            hideLoader();
        });
        hideLoader();
    }

    const onAwaitingTransferSelect = (clickedItem) => {
        setConvertOrderModal((prevFormData) => ({ ...prevFormData, transferItem: clickedItem.name, selectedTransferItem: clickedItem }));
    }

    const onChangeConvertionType = async (e) => {
        setConvertOrderModal((prevFormData) => ({ ...prevFormData, selectedReason: e.target.value }));
        if (e.target.value == ConversionMethodType.Transfer) {
            await getAwaitingTransfer();
        }
    }

    const getAwaitingTransfer = async () => {
        const response = await axiosPrivate.get(`v1/quotation/awaiting-transfer`).then(res => {
            setAwaitingTransfer(res.data.data);
        });
    }

    return (
        <>
            <HerosectionHeader name={"Transactions"} />
            {<Modal show={convertOrderModal.show} size="lg" onHide={() => setConvertOrderModal(ConvertOrderInitialValue)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Order : {convertOrderModal.orderNumber} </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="mt-3 align-items-center">
                        <Col md={4}> <Label for="cancelReason">Conversion Method</Label></Col>
                        <Col md={8}> <select
                            className="form-select"
                            id="cancelReason"
                            onChange={onChangeConvertionType}
                            value={convertOrderModal.selectedReason}
                        >
                            <option value="">Select type</option>
                            {CoversionMethodTypeData && CoversionMethodTypeData.length > 0 && CoversionMethodTypeData.map((m) => (
                                <option key={m.id} value={m.id}>{m.displayName}</option>
                            ))}
                        </select></Col>

                    </Row>
                    {
                        convertOrderModal.selectedReason == ConversionMethodType.Transfer &&
                        <Row className="mt-3 align-items-center">
                            <Col md={4}> <Label for="cancelReason">Transfer Item</Label></Col>
                            <Col md={8}><div className="align-items-center">
                                <AutoCompleteInput
                                    name="awaitingOrder"
                                    label="Awaiting Order"
                                    placeholder="Awaiting Order"
                                    value={convertOrderModal.transferItem}
                                    options={awaitingTransfer}
                                    onSuggestionClick={onAwaitingTransferSelect}
                                    handleChange={(event) => setConvertOrderModal((prevFormData) => ({ ...prevFormData, transferItem: event.target.value }))}
                                />
                                {/* <input type="text" value={transferSearchValue} onChange={(e) => setTransferSearchValue(e.target.value)} className="form-control" name="nameStartsWith" placeholder="search" /> */}

                            </div></Col>
                            {/* <Col md={4}> <div className="mt-5 d-flex">
                                <SpinnerButton type="button" className="btn btn-primary btn-sm" loading={loading} onClick={fetchInspectors} text="Search" />
                            </div></Col> */}

                        </Row>
                    }

                    {convertOrderModal.selectedReason == ConversionMethodType.PaymentId && <Row className="mt-3 align-items-center">
                        <Col md={4}> <Label for="paymentIntentId">Payment Id</Label></Col>
                        <Col> <Input type="text" id="paymentIntentId" className="form-input" onChange={(e) => setConvertOrderModal((prevFormData) => ({ ...prevFormData, paymentIntentId: e.target.value }))}  ></Input></Col>
                    </Row>
                    }

                    {(convertOrderModal.selectedReason == ConversionMethodType.Free || convertOrderModal.selectedReason == ConversionMethodType.Other) && <Row className="mt-3 align-items-center">
                        <Col md={4}> <Label for="description">Description</Label></Col>
                        <Col> <Input type="text" id="description" className="form-input" onChange={(e) => setConvertOrderModal((prevFormData) => ({ ...prevFormData, description: e.target.value }))}  ></Input></Col>
                    </Row>
                    }


                    {/* <Row className="mt-3 align-items-center">
                        <Col md={4}> <Label for="cancelReason">Description</Label></Col>
                        <Col> <Input type="text" id="description" className="form-input"  ></Input></Col>
                    </Row> */}
                    {/* <Row className="mt-3">
                        <Col>
                            <>
                                <input type="checkbox" className="form-check-input" id="isPaymentRefunded" checked={convertOrderModal.isPaymentRefunded} onChange={() => { setConvertOrderModal({ ...convertOrderModal, isPaymentRefunded: !convertOrderModal.isPaymentRefunded }) }} />
                                <span className="p-2" style={{ cursor: "pointer" }} onClick={() => { setConvertOrderModal({ ...convertOrderModal, isPaymentRefunded: !convertOrderModal.isPaymentRefunded }) }}>Payment is refunded</span>
                            </>
                        </Col>
                    </Row> */}
                    <Row>
                        <Col md={10}>
                            <div style={{ color: "red", fontSize: "0.9rem" }}>
                                {Object.keys(convertOrderModal?.validationError).length > 0 ? Object.values(convertOrderModal?.validationError).map((item,index) => <div key={index} className="row"><span>* {item}</span></div>) : null}
                            </div>
                        </Col>
                    </Row>

                    {convertOrderModal?.error && <Row className="mt-3">
                        <Col><span style={{ color: "red" }}>Error : {convertOrderModal?.error}</span></Col>
                    </Row>}
                </Modal.Body>
                <Modal.Footer>


                    <Row>
                        <Col md={2}></Col>
                        <Col md={4}><button className="btn btn-dark" onClick={() => setConvertOrderModal(ConvertOrderInitialValue)}>No</button></Col>
                        <Col md={6}>
                            <SpinnerButton text="Confirm" onClick={() => onConfirmConvertOrder(convertOrderModal.id)} className="btn btn-danger" />
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>}
            <div className="container">
                <Row>
                    <Col md={8}></Col>
                    <Col md={2}>
                        <div className="mt-5 d-flex align-items-center">
                            <select
                                className="form-select"
                                id="inputGroupSelect02"
                                onChange={handleOptionChange}
                                value={selectedStatus}
                            >
                                {OrderTransactionData && OrderTransactionData.length > 0 && OrderTransactionData.map((m) => (
                                    <option key={m.id} value={m.id}>{m.displayName}</option>
                                ))}
                            </select>
                        </div>
                    </Col>
                    <Col md={2}>
                        <div className="mt-5 d-flex align-items-end">
                            {/* <button type="button" className="btn btn-primary btn-sm" onClick={onSearchClick} >Search</button> */}
                            <SpinnerButton type="button" className="btn btn-primary btn-sm w-100 w-md-auto" loading={loading} onClick={onSearchClick} text="Search" />
                        </div>
                    </Col>

                </Row>
            </div>
            <div className="page-content">
                <section>
                    <Container>
                        <Row>

                            <div className="col">
                                <div className="table-responsive table-bordered border-bottom-0" style={{ fontSize: "14px" }}>
                                    <Table className="cart-table table text-center mb-0" >
                                        <thead className="bg-light">
                                            <tr>
                                                <th scope="col">Vehicle</th>
                                                <th scope="col">Date (UTC)</th>
                                                <th scope="col"> Step </th>
                                                <th scope="col">Requester</th>
                                                <th scope="col">Phone</th>
                                                <th scope="col">Email</th>
                                                <th scope="col">Vehicle Address</th>
                                                <th scope="col">Requester Note</th>
                                                <th scope="col">Reminder Count</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {transaction.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <div className="d-lg-flex align-items-center">
                                                            <VehicleTypeIcon vehicleType={item.vehicleType} width={40} />
                                                            <div className="ms-lg-3 mt-3 mt-lg-0">
                                                                <div
                                                                    // onClick={() =>
                                                                    //     navigate(`/product-single/${item.id}`)
                                                                    // }
                                                                    className="product-name"
                                                                >
                                                                    {/* {item.name} */}
                                                                    {item.make} / {item.model} / {item.year}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div>
                                                            {moment(item.createdDate).format('MM.DD.YYYY HH:mm')}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="mb-0">
                                                            {/* {item.quantity * item.salePrice} */}
                                                            {QuotationStepData.find((t) => t.id == item.quotationStep)?.displayName}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            {item.requesterFirstName} {item.requesterLastName}

                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            {item.requesterPhone}

                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            {item.requesterEmail}

                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            {item.sellerAddress}

                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            {item?.requesterNote}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            {item?.reminderCount}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            {/* <SpinnerButton type="button" className="btn btn-primary btn-sm" disabled={loading} loading={loading} onClick={() => onSendReminder(item.id)} text="Send Reminder" /> */}
                                                            <div className="dropdown">
                                                                <button className="btn btn-secondary dropdown-toggle btn-sm" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                    Actions
                                                                </button>
                                                                <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                                                    <button className="dropdown-item" type="button" disabled={loading} onClick={() => onSendReminder(item.id)}>Send Reminder</button>
                                                                    <button className="dropdown-item" type="button" disabled={item.quotationStep != QuotationStep.Payment} onClick={() => { setConvertOrderModal({ ...convertOrderModal, show: true, orderNumber: item.orderNumber, id: item.id }) }}>Convert to Order</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>

                                    </Table>

                                </div>
                                {transaction.length == 0 && <div> <EmptyDataResult message="There is no data to display" /></div>}
                            </div>
                        </Row>
                    </Container>
                </section>
            </div>


        </>

    )
}

export default Transaction;